import React, { useState, useEffect, useRef } from "react";
import IconMC from "./IconMC";

const PropertyListMC = ({
  properties,
  insertFieldInput,
  className = '',
  title = '',
  searchPlaceholder = 'Search...',
  noResultsText = 'No results found',
  style = {},
  onClose
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      onClose?.();
    }
  };

  const filteredProperties = properties.filter(field =>
    field[0].toLowerCase().includes(searchTerm.toLowerCase()) ||
    field[1].toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div
      className={`tw-bg-white tw-border tw-border-gray-200 tw-rounded-lg tw-shadow-lg tw-overflow-hidden tw-z-50 tw-flex tw-flex-col ${className}`}
      style={style}
      onKeyDown={handleKeyDown}
    >
      <div className="tw-px-4 tw-py-2 tw-text-[11px] tw-font-bold tw-text-gray-500 tw-bg-gray-50 tw-border-b tw-border-gray-100 uppercase tw-tracking-wider">
        {title}
      </div>

      <div className="tw-p-2 tw-border-b tw-border-gray-100 tw-bg-white">
        <div className="tw-relative tw-flex tw-items-center">
          <div className="tw-absolute tw-left-2 tw-text-gray-400">
            <IconMC name="search-outline" size="xs" />
          </div>
          <input
            ref={inputRef}
            type="text"
            className="tw-w-full tw-pl-7 tw-pr-3 tw-py-1.5 tw-text-xs tw-border tw-border-gray-200 tw-rounded-md focus:tw-outline-none focus:tw-border-blue-300 tw-bg-gray-50/50"
            placeholder={searchPlaceholder}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      <div className="tw-overflow-y-auto tw-flex-1 tw-max-h-[220px]">
        <div className="tw-py-1">
          {filteredProperties.length > 0 ? (
            filteredProperties.map((field, index) => (
              <div
                key={`customer-field-${index}`}
                className="tw-px-4 tw-py-2 tw-text-sm tw-text-gray-700 tw-cursor-pointer hover:tw-bg-blue-50 hover:tw-text-blue-600 tw-transition-colors tw-flex tw-items-center tw-gap-2"
                onClick={() => insertFieldInput(field)}
              >
                <span className="tw-text-default tw-font-medium">{field[0]}</span>
                <span className="tw-text-[10px] tw-text-gray-400 tw-font-mono tw-bg-gray-50 tw-px-1 tw-rounded">{`{{${field[1]}}}`}</span>
              </div>
            ))
          ) : (
            <div className="tw-px-4 tw-py-3 tw-text-xs tw-text-gray-400 tw-text-center">
              {noResultsText}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PropertyListMC;
